export default [
    {
        path: "/iframe",
        redirect: "/iframe/budgetreport",
        name: "Iframe",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "budgetreport",
                name: "Công khai ngân sách",
                component: () => import("@/views/pages/PublicReportViewer"),
            },
            {
                path: "budgetreport/view/:id",
                name: "Chi tiết báo cáo công khai ngân sách",
                component: () => import("@/views/pages/PublicReportDetailViewer"),
            },
        ],
    }
]